export const PRICING_HEADING_CONSTANTS = {
  title: "GPU Pricing",
  consumer: "Consumer GPU",
  enterprise: "Enterprise GPU",
};
